import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material.module';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ModalSnackbarService } from '../../../services/modal-snackbar.service';
import { UserInfoComponent } from '../user-info/user-info.component';
import { AdminUser, AdminUsersService } from '../../../services/admin-users.service';
import { blankOpen } from '../../../misc/functions';

@Component({
  selector: 'app-search-user-list',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, FormsModule, UserInfoComponent],
  templateUrl: './admin-search-user.component.html',
  styleUrls: ['./admin-search-user.component.scss']
})
export class AdminSearchUserComponent implements OnInit {

  adminUsers: AdminUser[] = [];
  isLoaded = false;

  searchUsers?: AdminUser[] = undefined;

  login: string = '';
  name: string = '';
  cap_id: string = '';

  user?: AdminUser = undefined;

  isUpdateEmail = false;

  blankOpen = blankOpen;

  @Input() isDialogMode = false;
  @Output() selected = new EventEmitter<AdminUser>();

  constructor(
    private snackBar: ModalSnackbarService,
    private router: Router,
    public adminUsersService: AdminUsersService
  ) {}

  ngOnInit(): void {

    if (this.isDialogMode) {
      this.isLoaded = true;
    }
    else {
      this.adminUsersService.getAdminUsers().subscribe(res => {
        this.adminUsers = this.adminUsersService.parseData(res);
        this.isLoaded = true;
      });
    }
  }

  search() {
    this.user = undefined;
    this.adminUsersService.searchUsers(this.login, this.name, this.cap_id).subscribe(res => {
      this.searchUsers = this.adminUsersService.parseData(res);
    });
  }

  setUser(user: AdminUser) {
    if (this.isDialogMode) {
      this.selected.emit(user);
    }
    else {
      this.user = undefined;

      setTimeout(() => {
        this.user = user;
      }, 50);
    }
  }

}
